import {
  default as AntRadio,
  RadioProps as AntRadioProps,
} from "antd/lib/radio";

import React from "react";

export function Radio(props: AntRadioProps) {
  return <AntRadio {...props} />;
}

export namespace Radio {
  export const Button = AntRadio.Button;
  export const Group = AntRadio.Group;
}
